<template>
  <v-app id="welcome-wrap">
    <div>
      <!-- Header -->
      <header-welcome></header-welcome>

      <div class="sections">

        <div class="navigation link-element">
          <div v-if="!!dates.indexOf(parseInt(code))" 
            @click="pre()">이전 약관 보기</div>
          <div v-if=" dates.indexOf(parseInt(code))<dates.length-1" 
            @click="next()">다음 약관 보기</div>
        </div>

        <terms20200101 v-if="code==20200101"/>
        <terms20200501 v-if="code==20200501"/>

      </div>

      <!-- Footer -->
      <footer-welcome></footer-welcome>
    </div>
  </v-app>
</template>

<script>
import Terms20200101 from './CommercialTerms_20200101'
import Terms20200501 from './CommercialTerms_20200501'

export default {

  components: {
    Terms20200101,
    Terms20200501,
  },

  metaInfo() {
    return {
      title: "Commercial Terms"
    }
  },

  data() {
    return {
      dates: [20200101, 20200501],
    }
  },

  computed: {
    code() {
      return this.$route.params.code
    },
  },

  watch: {
    code: {
      async handler(val) {
        if (!val||!this.dates.includes(val)) {
          let to_code = this.dates[this.dates.length-1]
          let to = { name: 'commercial-termsform', params: {code: to_code }}
          this.$router.replace(to)
        }
      },
      immediate: true,
    },
  },

  methods: {
    pre() {
      let to_code = this.dates[this.dates.indexOf(this.code)-1]
      let to = { name: 'commercial-termsform', params: {code: to_code }}
      this.$router.replace(to)
    },

    next() {
      let to_code = this.dates[this.dates.indexOf(this.code)+1]
      let to = { name: 'commercial-termsform', params: {code: to_code }}
      this.$router.replace(to)
    },
  },
}
</script>

<style scoped>
  .sections {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 70px 20px;
    max-width: 1080px;
    margin: auto;
  }

  .section {
    margin-bottom: 1.5rem;
  }

  p {
      margin-bottom: 1.2rem !important;
      line-height: 1.7 !important;
  }

  .header-title {
    padding: 40px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-meta {
    padding: 20px 0;
    font-size: 16px;
    font-weight: 700;
  }

  .subtitle {
    padding: 20px 0;
    font-size: 20px;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/welcome/CommercialTerms.vue